import { render, staticRenderFns } from "./ButtonWithLoader.vue?vue&type=template&id=c6bed54c"
import script from "./ButtonWithLoader.vue?vue&type=script&lang=js"
export * from "./ButtonWithLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports